"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class QueryController {
    get signal() {
        return this.abortController.signal;
    }
    get hasStarted() {
        return this.hasTimedOut || this.timeoutId != null;
    }
    constructor({ timeout } = {}) {
        this.hasTimedOut = false;
        this.timeout = timeout || 65000; // 65 seconds. 5 seconds longer then the default haproxy timeout.
        this.abortController = new AbortController();
    }
    startTimeout() {
        if (!this.hasStarted) {
            this.timeoutId = window.setTimeout(() => {
                this.hasTimedOut = true;
                this.abort();
                this.timeoutId = null;
            }, this.timeout);
        }
    }
    cancelTimeout() {
        if (this.timeoutId) {
            window.clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    abort() {
        this.abortController.abort();
    }
}
exports.default = QueryController;
